
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 7l-1.534-1.855.085-2.446-2.386-.59L9.8 0 7.5.843 5.199 0 3.835 2.024 1.45 2.7l.085 2.446L0 7l1.534 1.94-.085 2.446 2.386.59L5.2 14l2.301-.843 2.3.843 1.364-2.108 2.386-.675-.085-2.446L15 7zM7.415 9.108L6.392 10.12 5.37 9.108l-1.79-1.77 1.023-1.013 1.79 1.771 4.006-3.963 1.023 1.012-4.006 3.963z","fill":"url(#paint0_linear_2933_1851)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_2933_1851","x1":"0","y1":"0","x2":"14.866","y2":"12.936","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#D89F00"}}),_c('stop',{attrs:{"offset":".474","stop-color":"#FCD035"}}),_c('stop',{attrs:{"offset":".776","stop-color":"#D89F00"}})])])])
          )
        }
      }
    